import { categoryIcons } from 'src/designSystem/Header/Header'
import { defaultIcon } from 'src/designSystem/icons'

const ICONS: Record<string, string | undefined> = categoryIcons

export const standardCategoryIcon = (category: string): string => ICONS[category] ?? defaultIcon
